var React = require('react');

function Design (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.458 15.158l2.22 1.169c.4.21.428.543.086.77l-.085.05-8.9 4.684c-.38.2-.977.223-1.406.067l-.152-.067-8.9-4.684c-.398-.21-.426-.542-.085-.77l.086-.05 2.22-1.17 6.679 3.516c.381.2.977.223 1.406.067l.153-.067 6.678-3.515zm0-4.737l2.22 1.169c.43.226.43.595 0 .82l-8.898 4.684c-.43.226-1.13.226-1.56 0L2.323 12.41c-.43-.225-.43-.594 0-.82l2.22-1.17 6.679 3.516c.429.226 1.13.226 1.559 0l6.678-3.515zM12.78 2.169l8.899 4.684c.429.226.429.595 0 .82l-8.9 4.684c-.428.225-1.13.225-1.558 0l-8.9-4.684c-.428-.225-.428-.594 0-.82l8.9-4.684c.429-.226 1.13-.226 1.559 0z","fillRule":"evenodd"}));
}

Design.defaultProps = {"width":"24","height":"24"};

module.exports = Design;

Design.default = Design;
